import { colors } from '../../theme'

interface ListItemProps {
  label: string
  children: any
}

export const ListItem = (props: ListItemProps) => {
  const { label, children } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 15 }}>
      <span style={{ fontSize: 11, color: colors.textSecondary }}>
        {label.toUpperCase()}
      </span>
      <span>{!children || children === ' ' ? '-' : children}</span>
    </div>
  )
}
